module.exports = __webpack_public_path__ + "static/img/i1.1ead690.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/article/iosMessageSet/i1.png
// module id = sHFq
// module chunks = 0